// extracted by mini-css-extract-plugin
module.exports = {"base":"Avatar_base__12WQP","large":"Avatar_large__39WWv"};